import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.apply.form');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

declare const WizRoute: any;

interface FormField {
    id: string;
    type: string;
    label: string;
    description?: string;
    placeholder?: string;
    required?: boolean;
    options?: string[];
    accept?: string;
    maxSize?: number;
    multiple?: boolean;
}

@Component({
    selector: 'wiz-page-apply-form',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.apply.form/view.scss */
:host {
  display: block;
}`],
})
export class PageApplyFormComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public slug: string = '';
    public loaded: boolean = false;
    public submitting: boolean = false;
    public notFound: boolean = false;
    public closed: boolean = false;
    public errorMessage: string = '';

    public ann: any = null;          // 공고 정보
    public fields: FormField[] = []; // 폼 필드
    public companyFields: any[] = []; // 활성 기업 정보 항목 (관리자 설정 기준)
    public companyCustom: FormField[] = []; // 추가 기업 정보 항목
    public companyExtra: any = {};   // 추가 항목 답변 { field_id: value }
    public companyExtraFiles: any = {}; // 추가 항목 파일 { field_id: File|File[] }

    // 기본 기업 정보
    public company: any = {
        company_name: '',
        registed_number: '',
        ceo_name: '',
        ceo_email: '',
        ceo_phone: '',
        business_area: '',
        employee_count: 0,
        revenue: 0,
        summary: '',
        requested_amount: 0,
    };

    // 동적 필드 답변 { field_id: value }
    public values: any = {};
    // 파일 답변 { field_id: File | File[] }
    public fileMap: any = {};
    // 검증 에러 { field_id: '메시지' }
    public errors: any = {};
    // 기본 필드 에러
    public companyErrors: any = {};

    // 동의
    public agreed: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        this.slug = WizRoute.segment.slug;
        if (!this.slug) {
            this.notFound = true;
            this.loaded = true;
            await this.service.render();
            return;
        }
        await this.load();
    }

    public async load() {
        const { code, data, message } = await wiz.call('get', { slug: this.slug });
        if (code === 404) {
            this.notFound = true;
            this.loaded = true;
            await this.service.render();
            return;
        }
        if (code !== 200) {
            this.errorMessage = message || '공고를 불러올 수 없습니다.';
            this.loaded = true;
            await this.service.render();
            return;
        }
        this.ann = data.data || data;
        if (this.ann.status !== 'open') {
            this.closed = true;
        }
        this.fields = (this.ann.form_schema && this.ann.form_schema.fields) || [];
        // 체크박스/멀티 필드 초기값
        for (const f of this.fields) {
            if (f.type === 'checkbox') this.values[f.id] = [];
        }
        // 기업 정보 항목: 관리자 설정 우선, 없으면 기본 9종 사용
        const cs = this.ann.settings?.company || {};
        const defaults = [
            { key: 'company_name',    label: '기업명',          inputType: 'text',     enabled: true, required: true,  locked: true },
            { key: 'registed_number', label: '사업자등록번호',  inputType: 'text',     enabled: true, required: false, locked: false, placeholder: '000-00-00000' },
            { key: 'business_area',   label: '사업분야',        inputType: 'text',     enabled: true, required: false, locked: false },
            { key: 'ceo_name',        label: '대표자명',        inputType: 'text',     enabled: true, required: true,  locked: false },
            { key: 'ceo_phone',       label: '연락처',          inputType: 'tel',      enabled: true, required: true,  locked: false, placeholder: '010-0000-0000' },
            { key: 'ceo_email',       label: '이메일',          inputType: 'email',    enabled: true, required: true,  locked: true, hint: '접수번호와 결과 안내가 발송됩니다' },
            { key: 'employee_count',  label: '임직원 수',       inputType: 'number',   enabled: true, required: false, locked: false },
            { key: 'revenue',         label: '전년 매출 (원)',  inputType: 'number',   enabled: true, required: false, locked: false },
            { key: 'summary',         label: '사업 요약',       inputType: 'textarea', enabled: true, required: false, locked: false },
        ];
        const cfgList = Array.isArray(cs.fields) && cs.fields.length > 0 ? cs.fields : defaults;
        const cfgByKey: any = {}; for (const f of cfgList) cfgByKey[f.key] = f;
        // 정렬: cfgList 순서대로, locked는 enabled/required 강제
        this.companyFields = cfgList
            .map((c: any) => {
                const def = defaults.find(d => d.key === c.key) || {};
                const merged: any = { ...def, ...c };
                if (merged.locked) { merged.enabled = true; merged.required = true; }
                return merged;
            })
            .filter((f: any) => f.enabled);
        this.companyCustom = Array.isArray(cs.custom) ? cs.custom : [];
        // 추가 항목 체크박스 초기값
        for (const f of this.companyCustom) {
            if (f.type === 'checkbox') this.companyExtra[f.id] = [];
        }
        this.loaded = true;
        await this.service.render();
    }

    public companyFieldEnabled(key: string): boolean {
        return !!this.companyFields.find(f => f.key === key);
    }

    public companyFieldRequired(key: string): boolean {
        const f = this.companyFields.find(x => x.key === key);
        return !!(f && f.required);
    }

    public onCompanyExtraCheckbox(field: FormField, opt: string, ev: any) {
        if (!Array.isArray(this.companyExtra[field.id])) this.companyExtra[field.id] = [];
        const arr: string[] = this.companyExtra[field.id];
        if (ev.target.checked) {
            if (!arr.includes(opt)) arr.push(opt);
        } else {
            const i = arr.indexOf(opt);
            if (i >= 0) arr.splice(i, 1);
        }
    }

    public onCompanyExtraFileChange(field: FormField, ev: any) {
        const files: FileList = ev.target.files;
        if (!files || files.length === 0) {
            delete this.companyExtraFiles[field.id];
            return;
        }
        if (field.multiple) {
            this.companyExtraFiles[field.id] = Array.from(files);
        } else {
            this.companyExtraFiles[field.id] = files[0];
        }
    }

    public companyExtraFileLabel(field: FormField): string {
        const v = this.companyExtraFiles[field.id];
        if (!v) return '파일을 선택하세요';
        if (Array.isArray(v)) return `${v.length}개 파일 선택됨`;
        return (v as File).name;
    }

    public onCheckbox(field: FormField, opt: string, ev: any) {
        if (!Array.isArray(this.values[field.id])) this.values[field.id] = [];
        const arr: string[] = this.values[field.id];
        if (ev.target.checked) {
            if (!arr.includes(opt)) arr.push(opt);
        } else {
            const i = arr.indexOf(opt);
            if (i >= 0) arr.splice(i, 1);
        }
    }

    public onFileChange(field: FormField, ev: any) {
        const files: FileList = ev.target.files;
        if (!files || files.length === 0) {
            delete this.fileMap[field.id];
            return;
        }
        if (field.multiple) {
            this.fileMap[field.id] = Array.from(files);
        } else {
            this.fileMap[field.id] = files[0];
        }
    }

    public fileLabel(field: FormField): string {
        const v = this.fileMap[field.id];
        if (!v) return '파일을 선택하세요';
        if (Array.isArray(v)) return `${v.length}개 파일 선택됨`;
        return (v as File).name;
    }

    private _validate(): boolean {
        this.errors = {};
        this.companyErrors = {};
        let ok = true;
        // 기본 항목: 관리자 설정의 enabled/required 기준
        for (const cf of this.companyFields) {
            if (!cf.required) continue;
            const v = this.company[cf.key];
            if (v === undefined || v === null || String(v).trim() === '') {
                this.companyErrors[cf.key] = `${cf.label}은(는) 필수입니다.`;
                ok = false;
            }
        }
        // 이메일 형식 (활성화된 경우)
        if (this.companyFieldEnabled('ceo_email') && this.company.ceo_email?.trim()) {
            if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.company.ceo_email)) {
                this.companyErrors.ceo_email = '올바른 이메일 형식이 아닙니다.';
                ok = false;
            }
        }
        // 추가 기업 정보 항목 검증
        for (const f of this.companyCustom) {
            if (f.type === 'section') continue;
            if (!f.required) continue;
            if (f.type === 'file') {
                if (!this.companyExtraFiles[f.id]) { this.errors['cx_' + f.id] = '파일을 첨부하세요.'; ok = false; }
                continue;
            }
            const v = this.companyExtra[f.id];
            if (f.type === 'checkbox') {
                if (!Array.isArray(v) || v.length === 0) { this.errors['cx_' + f.id] = '하나 이상 선택하세요.'; ok = false; }
                continue;
            }
            if (v === undefined || v === null || String(v).trim() === '') {
                this.errors['cx_' + f.id] = '필수 항목입니다.'; ok = false;
            }
        }
        // 추가 항목 파일 크기 체크
        for (const f of this.companyCustom) {
            if (f.type !== 'file') continue;
            const v = this.companyExtraFiles[f.id];
            if (!v) continue;
            const max = f.maxSize || 10 * 1024 * 1024;
            const arr = Array.isArray(v) ? v : [v];
            for (const file of arr) {
                if ((file as File).size > max) {
                    this.errors['cx_' + f.id] = `파일 크기가 ${(max / 1024 / 1024).toFixed(1)}MB를 초과합니다.`;
                    ok = false;
                    break;
                }
            }
        }

        // 동적 필드
        for (const f of this.fields) {
            if (f.type === 'section') continue;
            if (!f.required) continue;
            if (f.type === 'file') {
                if (!this.fileMap[f.id]) { this.errors[f.id] = '파일을 첨부하세요.'; ok = false; }
                continue;
            }
            const v = this.values[f.id];
            if (f.type === 'checkbox') {
                if (!Array.isArray(v) || v.length === 0) { this.errors[f.id] = '하나 이상 선택하세요.'; ok = false; }
                continue;
            }
            if (v === undefined || v === null || String(v).trim() === '') {
                this.errors[f.id] = '필수 항목입니다.'; ok = false;
            }
        }

        // 파일 크기 체크
        for (const f of this.fields) {
            if (f.type !== 'file') continue;
            const v = this.fileMap[f.id];
            if (!v) continue;
            const max = f.maxSize || 10 * 1024 * 1024;
            const arr = Array.isArray(v) ? v : [v];
            for (const file of arr) {
                if ((file as File).size > max) {
                    this.errors[f.id] = `파일 크기가 ${(max / 1024 / 1024).toFixed(1)}MB를 초과합니다.`;
                    ok = false;
                    break;
                }
            }
        }

        if (!this.agreed) {
            this.errorMessage = '개인정보 수집·이용에 동의해주세요.';
            ok = false;
        }
        return ok;
    }

    public async submit() {
        this.errorMessage = '';
        if (!this._validate()) {
            await this.service.render();
            // 첫 에러로 스크롤
            setTimeout(() => {
                const el = document.querySelector('.field-error');
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 50);
            return;
        }
        this.submitting = true;
        await this.service.render();

        // FormData 구성 (파일 동시 전송)
        const fd = new FormData();
        fd.append('slug', this.slug);
        fd.append('company', JSON.stringify(this.company));
        fd.append('company_extra', JSON.stringify(this.companyExtra));
        fd.append('form_data', JSON.stringify(this.values));
        // file_map: { field_id: [filename, ...] } — 서버에서 매핑용
        const fileFieldList: any[] = [];
        // 추가 기업 정보 파일
        for (const fid of Object.keys(this.companyExtraFiles)) {
            const v = this.companyExtraFiles[fid];
            const arr = Array.isArray(v) ? v : [v];
            for (const f of arr) {
                fd.append('files', f as File);
                fileFieldList.push({ field_id: 'company_extra:' + fid, filename: (f as File).name });
            }
        }
        for (const fid of Object.keys(this.fileMap)) {
            const v = this.fileMap[fid];
            const arr = Array.isArray(v) ? v : [v];
            for (const f of arr) {
                fd.append('files', f as File);
                fileFieldList.push({ field_id: fid, filename: (f as File).name });
            }
        }
        fd.append('file_meta', JSON.stringify(fileFieldList));

        let res: any;
        try {
            const r = await fetch(`/wiz/api/page.apply.form/submit`, {
                method: 'POST', body: fd,
            });
            res = await r.json();
        } catch (e: any) {
            this.submitting = false;
            this.errorMessage = '네트워크 오류: ' + (e.message || e);
            await this.service.render();
            return;
        }
        this.submitting = false;
        if (res.code !== 200) {
            this.errorMessage = res.message || '제출에 실패했습니다.';
            await this.service.render();
            return;
        }
        // 완료 페이지로 이동
        this.service.href(`/apply/complete/${res.data.application_id}`);
    }
}

export default PageApplyFormComponent;